import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import defer from 'lodash/defer';
import forEach from 'lodash/forEach';
import remove from 'lodash/remove';
import has from 'lodash/has';
import * as urlUtils from 'privates/urlUtils';
import * as pm from 'privates/postMessage';

const onReadyCallbacks = [];
const onRenderCallbacks = [];
const ready = new Set();

function wrapCallbackWithTimer(callback, id) {
    return () => {
        const startTime = Date.now();
        const result = callback();
        if (result instanceof Promise) {
            result.then(() => {
                console.log(`${id} was delayed by ${Date.now() - startTime}ms due to code`);
            });
        }
        return result;
    };
}

function safeRun(callback) {
    try {
        return callback();
    } catch (e) {
        console.error(e);
        return null;
    }
}

function on(callback, callbacksArr, log, type) {
    if (!isFunction(callback)) {
        throw new Error(`${callback} is invalid. You can't select components before the document is ready.`);
    }

    const actualCallback = log ? wrapCallbackWithTimer(callback, log) : callback;
    if (ready.has(type)) {
        defer(() => safeRun(actualCallback));
    }

    callbacksArr.push(actualCallback);
}

function trigger(success, callbacksArr) {
    const allReady = Promise.all(callbacksArr.map((cb) => safeRun(cb))).then((res) => {
        const items = remove(res, (item) => !(isUndefined(item) || has(item, 'controllerId')));
        forEach(items, (data) => pm.sendMessage(pm.Intent.WIX_CODE_WARMUP, pm.MessageTypes.SET_WARMUP_DATA, {
            controllerId: 'wix-code',
            data
        }));
    }).catch((reason) => {
        console.error(reason);
    });
    if (success) {
        allReady.then(() => success());
    }

    callbacksArr.length = 0;
}

export function onReady(callback, log) {
    on(callback, onReadyCallbacks, log, 'ready');
}

export function triggerOnReady(success) {
    ready.add('ready');
    onReadyCallbacks.push(() => {
        urlUtils.addQueryParameters({renderCycle: NaN});
    });
    trigger(success, onReadyCallbacks);

}

export function onRender(callback, log) {
    on(callback, onRenderCallbacks, log, 'render');
}

export function triggerOnRender(success) {
    ready.add('render');
    trigger(success, onRenderCallbacks);
}


// WEBPACK FOOTER //
// ./js/modules/privates/readyManager.es6